import '@styles/pages/politique-de-confidentialite.scss';

import { initAnchor } from '@organisms/anchor';

initAnchor();
